import { getCollectionCacheKey } from '@src/pages/[...slug]/components/collection/utils'
import { createTargetURL } from '@src/quince-site-common/src/hooks/useQueryState'
import collectionCacheStateManager from '@src/quince-site-common/src/redux/globalStateManager/CollectionCacheStateManager'
import { isBrowser } from '@src/quince-site-common/src/utils/windowUtil'

export const QUERY_KEYS: ('filter' | 'sortBy')[] = ['filter', 'sortBy']

export const handleFilterSectionScroll = (filterSectionRef: React.RefObject<HTMLDivElement>) => {
  if (filterSectionRef.current && isBrowser()) {
    // Check if filterSectionRef is visible in viewport
    const filterSectionRect = filterSectionRef.current.getBoundingClientRect()
    const isFilterSectionVisible =
      filterSectionRect.top >= 0 &&
      filterSectionRect.left >= 0 &&
      filterSectionRect.bottom <= window.innerHeight &&
      filterSectionRect.right <= window.innerWidth

    // If not visible and user has scrolled past it (filterSectionRect.top is negative), scroll to it
    if (!isFilterSectionVisible && filterSectionRect.top < 0) {
      const headerHeight = document.querySelector('#site-primary-header')?.getBoundingClientRect().height ?? 0
      const SCROLL_TOP_PADDING = 16
      const top = window.pageYOffset + filterSectionRect.top - headerHeight - SCROLL_TOP_PADDING
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}

export const resetCollectionCacheOnFilterChange = ({
  pathname,
  searchParams,
  updatedWatchedQueryState,
}: {
  pathname: string
  searchParams: string
  updatedWatchedQueryState: { filter: string; sortBy: string | undefined }
}) => {
  if (!isBrowser()) return

  const targetURLSearchParams = createTargetURL({
    updatedWatchedQueryState,
    searchParams: new URLSearchParams(searchParams),
    queryKeys: QUERY_KEYS,
  })

  const destinationSearchParams = targetURLSearchParams.slice(1) // remove leading ?
  const cacheKey = getCollectionCacheKey(pathname, destinationSearchParams)
  const collectionCache = collectionCacheStateManager.getCollectionCache(cacheKey)
  if (collectionCache) {
    collectionCacheStateManager.publishCollectionCache(cacheKey, 0)
  }
}
